import React, { forwardRef } from "react";

type CardPanelVariant = "default" | "dropdown" | "tile" | "header";

type CardPanelProps = {
  variant?: CardPanelVariant;
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  id?: string;
};

const variantClasses: Record<CardPanelVariant, string> = {
  default: "rounded-xl bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark",
  dropdown: "fixed z-50 max-h-96 overflow-y-auto rounded-xl shadow-shadow dark:shadow-shadow-dark drop-shadow-lg bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark",
  tile: "rounded-xl bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark shadow-card dark:shadow-card-dark",
  header: "rounded-xl bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark",
};

const CardPanel = forwardRef<HTMLDivElement, CardPanelProps>(
  ({ variant = "default", className, children, onClick, id }, ref) => {
    const baseClasses = variantClasses[variant];
    const combinedClassName = className ? `${baseClasses} ${className}` : baseClasses;

    if (onClick) {
      return (
        <button
          ref={ref as React.Ref<HTMLButtonElement>}
          id={id}
          type="button"
          className={combinedClassName}
          onClick={onClick}
        >
          {children}
        </button>
      );
    }

    return (
      <div ref={ref} id={id} className={combinedClassName}>
        {children}
      </div>
    );
  }
);

CardPanel.displayName = "CardPanel";

export default CardPanel;


